import {
  GET_CURRENT_INSTRUCTOR_FAILURE,
  GET_CURRENT_INSTRUCTOR_REQUEST,
  GET_CURRENT_INSTRUCTOR_SUCCESS,
  GET_INSTRUCTORS_FAILURE,
  GET_INSTRUCTORS_REQUEST,
  GET_INSTRUCTORS_SUCCESS,
  GET_INSTRUCTOR_DETAIL_FAILURE,
  GET_INSTRUCTOR_DETAIL_REQUEST,
  GET_INSTRUCTOR_DETAIL_SUCCESS,
  GET_INSTRUCTOR_WITH_COURSES_FAILURE,
  GET_INSTRUCTOR_WITH_COURSES_REQUEST,
  GET_INSTRUCTOR_WITH_COURSES_SUCCESS,
  GET_MY_STUDENTS_FAILURE,
  GET_MY_STUDENTS_REQUEST,
  GET_MY_STUDENTS_SUCCESS,
  RESET_ALL_ACTIONS,
  UPDATE_INSTRUCTOR_DETAIL_FAILURE,
  UPDATE_INSTRUCTOR_DETAIL_REQUEST,
  UPDATE_INSTRUCTOR_DETAIL_SUCCESS,
} from "./ActionType";

const initialState = {
  detailUpdateResult: null,
  errorDetailUpdate: null,
  loadingDetailUpdate: false,
  instructorDetail: null,
  loadingInstructorDetail: false,
  errorInstructorDetail: null,
  currentInstructor: null,
  loadingCurrentInstructor: false,
  errorCurrentInstructor: null,
  myStudents: null,
  loadingMyStudents: false,
  errorMyStudents: null,
  loadingInstructorWithCourses: false,
  errorInstructorWithCourses: null,
  instructorWithCourses: null,
  loadingInstructors: false,
  errorInstructors: null,
  instructors: null,
};

export const instructorReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_INSTRUCTOR_DETAIL_REQUEST:
      return {
        ...state,
        loadingDetailUpdate: true,
        errorDetailUpdate: null,
      };
    case UPDATE_INSTRUCTOR_DETAIL_SUCCESS:
      return {
        ...state,
        loadingDetailUpdate: false,
        detailUpdateResult: action.payload,
        errorDetailUpdate: null,
      };
    case UPDATE_INSTRUCTOR_DETAIL_FAILURE:
      return {
        ...state,
        loadingDetailUpdate: false,
        errorDetailUpdate: action.payload,
      };
    case GET_INSTRUCTOR_DETAIL_REQUEST:
      return {
        ...state,
        loadingInstructorDetail: true,
        errorInstructorDetail: null,
      };
    case GET_INSTRUCTOR_DETAIL_SUCCESS:
      return {
        ...state,
        loadingInstructorDetail: false,
        instructorDetail: action.payload,
        errorInstructorDetail: null,
      };
    case GET_INSTRUCTOR_DETAIL_FAILURE:
      return {
        ...state,
        loadingInstructorDetail: false,
        errorInstructorDetail: action.payload,
      };
    case GET_CURRENT_INSTRUCTOR_REQUEST:
      return {
        ...state,
        loadingCurrentInstructor: true,
        errorCurrentInstructor: null,
      };
    case GET_CURRENT_INSTRUCTOR_SUCCESS:
      return {
        ...state,
        loadingCurrentInstructor: false,
        currentInstructor: action.payload,
        errorCurrentInstructor: null,
      };
    case GET_CURRENT_INSTRUCTOR_FAILURE:
      return {
        ...state,
        loadingCurrentInstructor: false,
        errorCurrentInstructor: action.payload,
      };
    case GET_MY_STUDENTS_REQUEST:
      return {
        ...state,
        loadingMyStudents: true,
        errorMyStudents: null,
      };

    case GET_MY_STUDENTS_SUCCESS:
      return {
        ...state,
        loadingMyStudents: false,
        myStudents: action.payload,
        errorMyStudents: null,
      };

    case GET_MY_STUDENTS_FAILURE:
      return {
        ...state,
        loadingMyStudents: false,
        errorMyStudents: action.payload,
      };
    case GET_INSTRUCTOR_WITH_COURSES_REQUEST:
      return {
        ...state,
        loadingInstructorWithCourses: true,
        errorInstructorWithCourses: null,
      };
    case GET_INSTRUCTOR_WITH_COURSES_SUCCESS:
      return {
        ...state,
        loadingInstructorWithCourses: false,
        instructorWithCourses: action.payload,
        errorInstructorWithCourses: null,
      };
    case GET_INSTRUCTOR_WITH_COURSES_FAILURE:
      return {
        ...state,
        loadingInstructorWithCourses: false,
        errorInstructorWithCourses: action.payload,
      };
    case GET_INSTRUCTORS_REQUEST:
      return {
        ...state,
        loadingInstructors: true,
        errorInstructors: null,
      };
    case GET_INSTRUCTORS_SUCCESS:
      return {
        ...state,
        loadingInstructors: false,
        instructors: action.payload,
        errorInstructors: null,
      };
    case GET_INSTRUCTORS_FAILURE:
      return {
        ...state,
        loadingInstructors: false,
        errorInstructors: action.payload,
      };
    case RESET_ALL_ACTIONS:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
